import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()
    return appStore.isLoggedIn()
}

// getUserRole reads the role claim straight from the JWT payload, so route guards
// can enforce access before the async /me call in the Default layout resolves.
// Returns '' when there is no (valid) token.
export const getUserRole = (): string => {
    const appStore = useAppStore()
    const jwt = appStore.getJWT()
    if (!jwt) return ''

    try {
        const payload = jwt.split('.')[1]
        const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
        return (JSON.parse(json).role as string) || ''
    } catch {
        return ''
    }
}
